export default __webpack_public_path__ + "static/media/image_3.71251aa7.svg";